import { useEffect } from 'react'

import { QuizEndingView, QuizPlayer, ThemeProvider } from '@guidde/design-system'
import { Box, styled } from '@mui/material'

import { QuickGuiddeType } from 'app/types'
import { useWindowView } from 'hooks'

import { QuizPlaybackPlayer, useQuizPlayback } from './use-quiz-playback'

const Overlay = styled(Box)({
    position: 'absolute',
    inset: 0,
    zIndex: 15,
    backgroundColor: '#fff',
    borderRadius: 12,
    margin: -1,
})

type Props = {
    playbook: QuickGuiddeType
    player: QuizPlaybackPlayer | null
}

export const QuizPlaybookOverlay = ({ playbook, player }: Props) => {
    const { mdDown: isMobileView } = useWindowView()
    const { view, submitAttempt, continueGuide, rewatch, retake, skip, reviewGuide } = useQuizPlayback(playbook, player)

    const lockScroll = isMobileView && view.type !== 'idle'

    // lock background scroll while the full-screen mobile quiz is up
    useEffect(() => {
        if (!lockScroll) return
        const previous = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return () => {
            document.body.style.overflow = previous
        }
    }, [lockScroll])

    if (view.type === 'idle') return null

    return (
        <ThemeProvider>
            <Overlay
                sx={
                    isMobileView
                        ? {
                              position: 'fixed',
                              inset: 'auto',
                              top: 55,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              margin: 0,
                              borderRadius: 0,
                              overflowY: 'auto',
                              zIndex: 1200,
                          }
                        : undefined
                }
            >
                {view.type === 'quiz' ? (
                    <QuizPlayer
                        key={view.quiz.id}
                        quiz={view.quiz}
                        onSubmitAttempt={submitAttempt}
                        onContinue={continueGuide}
                        onRewatch={rewatch}
                        onRetake={retake}
                        onSkip={skip}
                    />
                ) : (
                    <QuizEndingView onReviewGuide={reviewGuide} />
                )}
            </Overlay>
        </ThemeProvider>
    )
}
